import { inject, Injectable } from '@angular/core';
import { ActiveCartService } from '@cart/data-access';
import { ReceiptTypeCodes } from '@checkout-v2/const';
import { CheckoutActions, CheckoutApiService } from '@checkout-v2/data-access';
import { Actions, createEffect, EffectNotification, ofType, OnRunEffects } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Observable, of } from 'rxjs';
import { catchError, exhaustMap, filter, map, switchMap, takeUntil } from 'rxjs/operators';
import { ReceiptService } from '../services';

@Injectable()
export class ReceiptTypesEffects implements OnRunEffects {
  private readonly actions$ = inject(Actions);
  private readonly checkoutApiService = inject(CheckoutApiService);
  private readonly activeCartService = inject(ActiveCartService);
  private readonly receiptService = inject(ReceiptService);

  // Запрос в апи
  // Загрузка списка способов получения
  loadReceiptTypes$: Observable<CheckoutActions.LoadReceiptTypeSuccess | CheckoutActions.LoadReceiptTypeFail> =
    createEffect(() =>
      this.actions$.pipe(
        ofType<CheckoutActions.LoadReceiptType>(CheckoutActions.LOAD_RECEIPT_TYPE),
        concatLatestFrom(() => this.activeCartService.getActiveCartId()),
        filter(([, cartId]) => !!cartId),
        switchMap(([, cartId]) => {
          return this.checkoutApiService.loadReceiptTypes(cartId).pipe(
            map((data) => new CheckoutActions.LoadReceiptTypeSuccess(data)),
            catchError((error) => of(new CheckoutActions.LoadReceiptTypeFail(error))),
          );
        }),
      ),
    );

  // -------------------------------------

  // Загружен список способов получения
  // Установить активный способ получения
  setDefaultReceiptTypeAfterLoad$: Observable<CheckoutActions.SetActiveReceiptType | CheckoutActions.SetShop> =
    createEffect(() =>
      this.actions$.pipe(
        ofType(CheckoutActions.LOAD_RECEIPT_TYPE_SUCCESS),
        concatLatestFrom(() => this.receiptService.activeReceiptTypeId$),
        filter(([, activeReceiptTypeId]) => !activeReceiptTypeId),
        map(() => new CheckoutActions.SetActiveReceiptType(ReceiptTypeCodes.Delivery)),
      ),
    );

  ngrxOnRunEffects(resolvedEffects$: Observable<EffectNotification>): Observable<EffectNotification> {
    return this.actions$.pipe(
      ofType(CheckoutActions.CHECKOUT_INIT),
      exhaustMap(() => resolvedEffects$.pipe(takeUntil(this.actions$.pipe(ofType(CheckoutActions.CHECKOUT_DESTROY))))),
    );
  }
}
